<template>
  <free-months-benefit-notification-box v-if="isGenericFeeMonthBenefit"/>
  <second-month-free-benefit-notification-box v-else-if="isSecondMonthFreeBenefit"/>
  <discount-promo-notification-box v-else-if="(!newPromotionsTest && eligibleForDiscountPromotion) || isDiscountBenefit"/>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import promotions from '@/constants/promotions';
import DiscountPromoNotificationBox from './DiscountPromoNotificationBox.vue';
import FreeMonthsBenefitNotificationBox from './FreeMonthsBenefitNotificationBox.vue';
import SecondMonthFreeBenefitNotificationBox from './SecondMonthFreeBenefitNotificationBox';

export default {
  name: 'BenefitNotificationFlow',
  components: {
    DiscountPromoNotificationBox,
    FreeMonthsBenefitNotificationBox,
    SecondMonthFreeBenefitNotificationBox,
  },
  computed: {
    ...mapState('benefits', ['benefitType', 'benefitPromotion']),
    ...mapGetters('benefits', ['BENEFIT_TYPES']),
    ...mapState('discountPromotion', ['eligibleForDiscountPromotion']),
    ...mapState('subscriptionState', ['newPromotionsTest']),
    isDiscountBenefit() {
      return !this.newPromotionsTest && this.benefitPromotion === promotions.PROMOTION_NAMES.DISCOUNT_TWO_MONTHS_FREE;
    },
    isGenericFeeMonthBenefit() {
      return !this.newPromotionsTest && this.benefitType === this.BENEFIT_TYPES.FREE_MONTHS && !this.isDiscountBenefit;
    },
    isSecondMonthFreeBenefit() {
      return !this.newPromotionsTest && this.benefitType === this.BENEFIT_TYPES.SECOND_MONTH_FREE;
    },
  },
};
</script>

<style scoped lang="scss">
</style>
